import { create } from "zustand";

type NewClientState = {
  open: boolean;
  /** Bumped on every open so the form starts fresh. */
  session: number;
};

export const useNewClientStore = create<NewClientState>(() => ({
  open: false,
  session: 0
}));

/** Open the New Client modal over the current screen. */
export const openNewClient = () =>
  useNewClientStore.setState((s) => ({ open: true, session: s.session + 1 }));

export const closeNewClient = () => useNewClientStore.setState({ open: false });
